import React, {useState} from 'react';
import getMenuOptions from "../../services/role_handler";
import {createStyles, makeStyles} from '@material-ui/core/styles';
import {List, ListItem} from "@material-ui/core";
import {useHistory, useLocation} from "react-router-dom";
import classNames from 'classnames';
import Typography from "@material-ui/core/Typography";
import {ReactComponent as HelpIcon} from "../../assets/help.svg";

const useStyles = makeStyles(theme =>
    createStyles({
        listItem: {
            textDecoration: 'none',
            color: theme.palette.primary.main,
            width: "100%",
            cursor: 'pointer',
            fontSize: 14,
            minHeight: 34,
            paddingLeft: 22,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginBottom: 7
        },

        listItemSelected: {
            color: theme.palette.secondary.main,
            borderLeft: '5px solid',
            paddingLeft: 17
        },

        listItemHelp: {
            position: 'absolute',
            bottom: 0,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
        },

        helpIcon: {
            marginRight: 13,
        },

        studentIndicator: {
            backgroundColor: theme.palette.warning.main,
            borderRadius: 3,
            fontSize: 12,
            color: 'white',
            fontWeight: 900,
            padding: "0 3px 0 3px",
            letterSpacing: -0.2,
            lineHeight: 'normal',
            marginTop: 2
        },
    }),
);

export default function ListOptions({role, studentsAtRisk}) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const [optionsBar] = useState(getMenuOptions(role));

    const handleClick = item => {
        history.push(item.link);
    };

    const isLocationFAQ = () => '/faq' === location.pathname

    const replacePathname = () => {
        const studentsDeepLink = '/students/'
        const coursesDeepLink = '/courses/'
        const professorsDeepLink = '/professors/'
        if (location.pathname.includes(studentsDeepLink)) return studentsDeepLink.substring(0, studentsDeepLink.length -1)
        if (location.pathname.includes(coursesDeepLink)) return role === 'Admin' ? '/' : '/' 
        if (location.pathname.includes(professorsDeepLink)) return professorsDeepLink.substring(0, professorsDeepLink.length -1)
        return location.pathname
    }
    return (
        <List style={{flexGrow: 1}}>
            {optionsBar.map((item) => (
                <ListItem key={item.name}
                          button
                          onClick={() => handleClick(item)}
                          className={classNames(classes.listItem, {[classes.listItemSelected]: item.link === replacePathname()})}>
                    <Typography variant={'body2'} color={'inherit'}> {item.name}</Typography>
                    {
                        studentsAtRisk && item.link === '/students' ?
                            <Typography className={classes.studentIndicator} variant={'caption'}>
                                {studentsAtRisk} Low Attendance</Typography> : null
                    }
                </ListItem>
            ))}

            <ListItem className={classNames(classes.listItem, classes.listItemHelp, {[classes.listItemSelected]: isLocationFAQ()})} button onClick={() => history.push('/faq')}>
            <svg className={classes.helpIcon} width="21px" height="18px" viewBox="0 0 21 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                <title>Group 3</title>
                <desc>Created with Sketch.</desc>
                <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.7">
                    <g id="Menu-/-Item-Help" transform="translate(-21.000000, -9.000000)" fill={isLocationFAQ() ? '#37b5ff' : '#177acc'} fillRule="nonzero">
                        <g id="Group-3" transform="translate(21.000000, 9.000000)">
                            <path d="M18.9919167,6.87169619e-15 L9.39938926,6.87169619e-15 C8.62683672,6.87169619e-15 8.00450272,0.622333992 8.00450272,1.39488653 L8.00450272,2.44641638 L10.9659541,2.44641638 C12.5754386,2.44641638 13.9059458,3.75546374 13.9059458,5.36494821 L13.9059458,11.287851 C14.5282797,12.0818634 15.5798096,13.262152 16.8030178,13.8630262 C16.888857,13.9059458 16.9961559,13.9274055 17.1034549,13.9274055 C17.2751332,13.9274055 17.4468116,13.8630262 17.5755703,13.7557272 C17.7901683,13.5625891 17.8545476,13.262152 17.7257889,13.0046345 C17.4253518,12.3179211 17.3395126,11.6741273 17.3180528,11.1805521 L18.9919167,11.1805521 C19.7644692,11.1805521 20.3868032,10.5582181 20.3868032,9.78566553 L20.3868032,1.37342674 C20.3868032,0.622333992 19.7644692,6.87169619e-15 18.9919167,6.87169619e-15 Z" id="Path"></path>
                            <path d="M10.9874139,3.97006167 L1.39488653,3.97006167 C0.622333992,3.97006167 -1.6688405e-14,4.59239566 -1.6688405e-14,5.36494821 L-1.6688405e-14,13.7557272 C-1.6688405e-14,14.5282797 0.622333992,15.1506137 1.39488653,15.1506137 L3.04729058,15.1506137 C3.02583079,15.644189 2.93999162,16.2879828 2.63955452,16.9746961 C2.53225555,17.2322136 2.57517514,17.5326507 2.78977307,17.7257889 C2.91853182,17.8545476 3.09021017,17.918927 3.26188851,17.918927 C3.36918747,17.918927 3.45502665,17.8974672 3.56232561,17.8545476 C4.87137297,17.2107538 5.96582241,15.9446261 6.5666966,15.1506137 L10.9874139,15.1506137 C11.7599665,15.1506137 12.3823005,14.5282797 12.3823005,13.7557272 L12.3823005,5.36494821 C12.3823005,4.59239566 11.7599665,3.97006167 10.9874139,3.97006167 Z M6.2877193,13.3050716 C5.85852344,13.3050716 5.51516676,12.9617149 5.51516676,12.532519 C5.51516676,12.1033232 5.85852344,11.7599665 6.2877193,11.7599665 C6.71691515,11.7599665 7.06027184,12.1033232 7.06027184,12.532519 C7.06027184,12.9617149 6.71691515,13.3050716 6.2877193,13.3050716 Z M8.15472127,9.33500988 C7.85428417,9.74274594 7.55384708,9.95734387 7.33924915,10.1075624 C7.08173163,10.2792408 6.97443267,10.3650799 6.95297288,10.772816 C6.91005329,10.9659541 6.75983474,11.0947129 6.5881564,11.0947129 L6.03020178,11.0947129 C5.81560386,11.0947129 5.66538531,10.9230345 5.6868451,10.7084366 C5.77268427,9.74274594 6.13750075,9.39938926 6.60961619,9.07749237 C6.80275433,8.94873361 6.97443267,8.81997485 7.14611101,8.58391713 C7.31778935,8.34785941 7.33924915,8.00450272 7.21049039,7.72552542 C7.10319143,7.53238728 6.84567391,7.21049039 6.24479971,7.21049039 C5.45078738,7.21049039 5.19326986,7.72552542 5.12889049,8.11180169 C5.10743069,8.28348003 4.95721214,8.41223879 4.7855338,8.41223879 L4.1846596,8.41223879 C3.97006167,8.41223879 3.79838333,8.21910065 3.84130292,8.00450272 C3.99152147,6.95297288 4.74261421,5.94436261 6.22333992,5.94436261 C7.14611101,5.94436261 7.94012335,6.39501826 8.32639962,7.14611101 C8.6697563,7.87574397 8.60537692,8.71267589 8.15472127,9.33500988 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </svg>
                <Typography variant={'body2'} color={'inherit'}> Help</Typography>
            </ListItem>
        </List>
    );
};
